






















































import { Vue, Component, Prop } from 'vue-property-decorator';
import SimpleMessageBox from '@/components/Shared/SimpleMessageBox.vue';

@Component({
  components: { SimpleMessageBox }
})
export default class SceneItem extends Vue {
  @Prop({ required: true }) scene!: any;
  // @Prop({ required: true }) index!: number;

  showConfirmDelete: boolean = false;

  transitions = [
    { value: 'None', label: 'Kein Übergang', icon: 'mdi-minus' },
    { value: 'ExtendPreviousScene', label: 'An Szene anknüpfen', icon: 'mdi-plus' },
    { value: 'FadeOutIn', label: 'Aus- und Einblenden', icon: 'mdi-transition' },
    { value: 'CrossFade', label: 'Überblenden', icon: 'mdi-transition-masked' }
  ];

  get currentTransition() {
    const val = this.scene?.transition || (this.scene?.extendPreviousScene ? 'ExtendPreviousScene' : 'None');
    return this.transitions.find(t => t.value === val) || this.transitions[0];
  }

  setTransition(val: string) {
    if (!this.scene) return;
    this.$set(this.scene, 'transition', val);
    // Legacy support: keep extendPreviousScene in sync if needed
    this.scene.extendPreviousScene = (val === 'ExtendPreviousScene');
  }

  get selectedStartFrameFile() {
    if (!this.scene || !this.scene.startFrameFiles || this.scene.startFrameFiles.length === 0) return null;
    return this.scene.startFrameFiles.find((f: any) => f.id === this.scene!.selectedStartFrameFileId) || null;
  }

  get previewImagePath() {
    if (this.scene.previewImage) return this.scene.previewImage;
    return this.selectedStartFrameFile?.filePath || null;
  }

  emitDelete() {
    this.showConfirmDelete = false;
    this.$emit('delete');
  }

  // Scene ordering is now managed by vuedraggable in the parent component.

  get extendStyle() {
    const isActive = this.currentTransition.value !== 'None';
    const bg = isActive ? this.$store.state.ux.colorAccent9 : 'rgba(0,0,0,0.4)';
    return {
      background: bg,
      cursor: 'pointer'
    };
  }
}
